import type { InterviewSettings } from '../../../api/settingsApi';

const MODE_LABELS: Record<string, string> = {
  technical: 'Technical',
  behavioral: 'Behavioral',
  professional: 'Professional',
};

/** Matches legacy (Luci) persona names in Settings — fallback when API preview is absent. */
export function resolveLegacyInterviewerName(
  mode: InterviewSettings['mode'] | string | undefined,
  gender: InterviewSettings['interviewer_gender'] | string | undefined
): string {
  const isTechnical = (mode ?? 'professional') === 'technical';
  const isFemale = (gender ?? 'female') !== 'male';
  if (isTechnical) {
    return isFemale ? 'Jacky' : 'Aditya';
  }
  return isFemale ? 'Clara' : 'Derek';
}

export function buildPracticeInterviewWidgetTitle(
  settings: Pick<InterviewSettings, 'mode' | 'interviewer_gender'>,
  interviewerName?: string
): string {
  const mode = settings.mode ?? 'professional';
  const modeLabel = MODE_LABELS[mode] ?? 'Practice';
  const name =
    interviewerName?.trim() ||
    resolveLegacyInterviewerName(settings.mode, settings.interviewer_gender);
  return `${modeLabel} Practice Interview with ${name}`;
}
